// JavaScript Document
jQuery(window).on('load', ()=>{
	console.log('products.js is loaded')
	/*15度づつの回転画像ｼ*/
	jQuery('#slider_15deg').slick({
		autoplay: true,
		autoplaySpeed: 2000,
		arrows: false,
		fade: true,
		speed: 0,
		slidesToShow: 1,
		centerMode: true,
	});
	jQuery('#slider_15deg_nav #slider_15deg_nav_prev').on('click', function () {
		console.log('llll');
		jQuery('#slider_15deg').slick('slickNext');
	});
	jQuery('#slider_15deg_nav #slider_15deg_nav_next').on('click', function () {
		jQuery('#slider_15deg').slick('slickPrev');
	});
	jQuery('#slider_15deg_nav #slider_15deg_nav_0').on('click', function () {
		jQuery('#slider_15deg').slick('slickGoTo', 0);
	});


	/*笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ繧ｫ繝ｩ繝舌Μ繧ｹ繝ｩ繧､繝繝ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ笆ｼ*/
	var slider_color;
	var slider_nav_color;
	var nav_index;
	var str;
	//繧ｹ繝ｩ繧､繝繝ｼ繝翫ン繧定､�｣ｽ
	jQuery('.wrap_color_variation_inner>div').each(function (index, element) {

		slider_color = jQuery(this).find('.slider_color');
		slider_nav_color = jQuery(this).find('.slider_nav_color');
		str = jQuery(slider_color.html().replace(/img-cl/g, 'img-thumb'));
		//console.log(str);
		slider_nav_color.prepend(str);

	});
		
					//繧ｹ繝ｩ繧､繝繝ｼ繧帝幕蟋�
			jQuery('.slider_color').slick({
				autoplay: false,
				fade: true,
			});
			jQuery('.slider_nav_color').on('click', 'div', function () {
				//console.log(jQuery(this).html());
				nav_index = jQuery(this).parent('.slider_nav_color').find('div').index(this);
				//console.log(jQuery(this).parent('.slider_nav_color').html());
				jQuery(this).parent('div.slider_nav_color').siblings('.slider_color').slick('slickGoTo', nav_index);
				console.log(nav_index);
			});
		

	/*商品ページ　機能紹介*/
	jQuery('#wrap_functions_others>div>div>h3').on('click', function () {
		jQuery(this).next('div').slideToggle();
		jQuery(this).toggleClass('ttl_functions_others_open');
	});

	/*商品ページ　機能紹介2025　ワンカラム*/
	jQuery('#wrap_functions_single>div>h2').on('click', function () {
		jQuery(this).next('div').slideToggle();
		jQuery(this).toggleClass('ttl_functions_others_open');
	});

	/*商品ページ　スペック2025　ワンカラム*/
	jQuery('#wrap_spec_single>div>h2').on('click', function () {
		jQuery(this).next('div').slideToggle();
		jQuery(this).toggleClass('ttl_functions_others_open');
	});
	
	/* よくある質問 */
	jQuery('#wrap_faq>div>div>h3').on('click', function () {
		jQuery(this).next('p').slideToggle();
		jQuery(this).toggleClass('ttl_functions_others_open');
	});

	/* よくある質問（色別用） */
	jQuery('.wrap_prod_faq>section>.wrap_q').on('click', function () {
		jQuery(this).next('.wrap_a').slideToggle();
		jQuery(this).toggleClass('ttl_functions_others_open');
	});
	
	/* 商品ページ 機能紹介（一部表示、残りアコーディオン） */
const openBtn = document.getElementById('openBtn');
const closeBtn = document.getElementById('closeBtn');
const content = document.getElementById('accordionContent');

/* 開く */
openBtn.addEventListener('click', () => {
  content.classList.add('open');
  openBtn.style.display = 'none';
});

/* 閉じる */
closeBtn.addEventListener('click', () => {
  content.classList.remove('open');
  openBtn.style.display = 'flex';
});




	/* 商品ページ着画イメージのスライダー */
	$(function () {
		$(".item_slider").slick({
		  arrows: false,
		  autoplay: true,
		  adaptiveHeight: true,
		  centerMode: true,
		  centerPadding: "25%",
		  dots: true,
			responsive: [{
				breakpoint: 768,
				settings: {
				arrows: false,
				autoplay: true,
				adaptiveHeight: true,
				centerMode: false,
				dots: true,
			},
			}],
		});
	});
})

window.addEventListener('load',()=>{
	console.log('product page is loaded')

	//商品詳細・コレクションページのおすすめシリーズスライダー
    let els_rec_series = document.querySelectorAll('.js-slider-rec-series')
    els_rec_series.forEach(el=>{
        let sw = new Swiper(el,{
			centeredSlides:true,
            loop:true,
            slidesPerView:1.4,
			slideToClickedSlide:true,
            spaceBetween:0,
			navigation: {
				nextEl: ".rec-series__arrow--next",
				prevEl: ".rec-series__arrow--prev",
			},
            breakpoints:{
                767:{
                  slidesPerView: 2.7
                }
            }
        })
		console.log(sw)
    })
})
